import {format, isValid, parse, startOfDay} from "date-fns";

export function formatDate(date) {
    return isValid(date) ? format(date, 'd.M.yyyy') : '';
}

export function parseDate(value) {
    try {
        const date = parse(value, 'd.M.yyyy', startOfDay(new Date()));
        if (!isValid(date)) {
            return null;
        }

        return date;
    } catch (err) {
        return null;
    }
}
